import React from "react";
import NoStoreImg from "./no-store.png";
import { gql } from "../../../__generated__";
import { useMutation, useQuery } from "@apollo/client";
import { useNavigate } from "react-router-dom";
import { notify } from "../../../utils/toast";
import FadeInWrapper from "../../../components/common/fade-in-wrapper";
import clsx from "clsx";
import { useAuth } from "../../../core/auth";
import { postMessage } from "../../../core/message";
import { track } from "@amplitude/analytics-browser";

const GET_WAIT_LIST = gql(`
  query getWaitList($loadAddr: String!) {
    waitList(loadAddr: $loadAddr) {
      uuid
    }
  }
`);
const CREATE_WAIT_LIST = gql(`
  mutation createWaitList($loadAddr: String!, $uuid: String!, $push_token: String) {
    createWaitList(loadAddr: $loadAddr, uuid: $uuid, push_token: $push_token) {
      uuid
    }
  }
`);
const IS_WAITED = gql(`
  query isWaited($uuid: String!) {
    isWaited(uuid: $uuid)
  }
`);

export const NoStore = ({ loadAddr }: { loadAddr?: string }) => {
  const navigate = useNavigate();
  const { doneOnboarding } = useAuth();
  const uuid = localStorage.getItem("mahi_uuid");
  const push_token = localStorage.getItem("expo_push_token");
  const addr = loadAddr || localStorage.getItem("loadAddr");
  const { data, refetch: refetchWaitList } = useQuery(GET_WAIT_LIST, {
    variables: { loadAddr: addr || "" },
  });
  const [createWaitList] = useMutation(CREATE_WAIT_LIST);
  const waitList = data?.waitList;
  const { data: isWaitedData, refetch: refetchIsWaited } = useQuery(IS_WAITED, {
    variables: { uuid: uuid || "" },
  });
  const isWaited = isWaitedData?.isWaited;
  const handleCreateWaitList = () => {
    notify("등록되었습니다 👋");
    createWaitList({
      variables: {
        loadAddr: loadAddr || "",
        uuid: uuid || "",
        push_token,
      },
      onCompleted: () => {
        refetchWaitList();
        refetchIsWaited();
        track("온보딩 대기 등록 완료", {
          loadAddr: loadAddr || "",
        });
      },
    });
  };
  const onClickGoHome = () => {
    postMessage("clear_history", "");
    postMessage("REQ_NOTIFICATION_TOKEN", ""); // 토큰 요청하라고 앱에게 메세지 보내기
    doneOnboarding();
    // localStorage에서 위치 정보 가져와서 URL에 포함
    const lat = localStorage.getItem("lat");
    const lng = localStorage.getItem("lng");
    const loadAddrValue = loadAddr || localStorage.getItem("loadAddr");
    const params = new URLSearchParams({ firstVisit: "true" });
    if (lat) params.set("lat", lat);
    if (lng) params.set("lng", lng);
    if (loadAddrValue) params.set("loadAddr", loadAddrValue);
    navigate(`/?${params.toString()}`, { replace: true });
  };
  return (
    <div className="w-full bg-[#fff]">
      <div className="relative w-full bg-[#fff]">
        <h1 className="text-3xl text-black font-extrabold mt-4 mb-4">
          <FadeInWrapper>
            {loadAddr && loadAddr !== "" ? (
              <>
                <span className="text-[#1692fc] font-bold mt-4">
                  {(loadAddr?.split(" ")[2] ? loadAddr?.split(" ")[2] : "") +
                    (loadAddr?.split(" ")[3]
                      ? " " + loadAddr?.split(" ")[3]
                      : "")}
                </span>
                에는 아직
                <br />
                마감할인 매장이 없어요 🥲
                <br />{" "}
              </>
            ) : (
              <>지역을 찾지 못했어요🥲</>
            )}
          </FadeInWrapper>
        </h1>

        {/* Image */}
        <img
          className="mx-auto w-2/3 max-w-xs h-auto opacity-50"
          alt="No Store Available"
          src={NoStoreImg}
        />
        {/* Highlight Box */}
        {loadAddr?.split(" ")[2] && (
          <div className="text-center bg-white rounded-lg p-4 mx-4 shadow-sm border border-[#e0e0e0] mb-6 text-lg">
            <div className="flex items-center justify-between">
              <p className="text-[#1692fc] font-semibold mb-2">마감할인 시작</p>
              <div className="flex justify-center text-[#464646]">
                <p className="font-bold text-4xl">30명</p>
              </div>
            </div>
            <div className="flex items-center justify-between mt-2">
              <p className="text-[#1692fc] font-semibold">대기인원</p>
              <div className="flex justify-center text-[#464646]">
                <p className="font-bold text-4xl text-purple-500">
                  {waitList?.length || 0}명
                </p>
              </div>
            </div>
            <p className="text-[#6d6d6d] mt-8 text-md text-left">
              *마감할인이 시작되면 알림을 드릴게요!
            </p>
          </div>
        )}
        <div className="flex justify-center">
          {loadAddr?.split(" ")[2] && (
            <FadeInWrapper className="inline w-full mt-4">
              <button
                className={clsx(
                  "w-full h-[60px] flex items-center justify-center rounded-3xl font-bold text-xl",
                  isWaited ? "bg-gray-400" : "bg-blue-500 text-white"
                )}
                disabled={isWaited || false}
                onClick={() => {
                  if (isWaited) {
                    return;
                  }
                  handleCreateWaitList();
                }}
              >
                {isWaited ? "등록 완료" : "대기 등록하기"}
              </button>
            </FadeInWrapper>
          )}
        </div>
        <div className="flex justify-center">
          <FadeInWrapper className="inline w-full mt-4">
            <button
              className="w-full h-[60px] flex items-center justify-center rounded-3xl font-bold bg-white border border-[#e0e0e0] text-xl"
              onClick={onClickGoHome}
            >
              홈으로 가기
            </button>
          </FadeInWrapper>
        </div>
      </div>
    </div>
  );
};

export default NoStore;
